// @flow

import styled from 'styled-components';
import { COLORS, FONT_WEIGHT, TYPE_SCALE, SPACING, LINE_HEIGHT } from 'clark-styles';
import Button from 'components/shared/button';

const { GREY_100 } = COLORS;
const { S_05, S_1, S_2, S_4 } = SPACING;
const { FW_100, FW_700 } = FONT_WEIGHT;
const { TS_3, TS_6 } = TYPE_SCALE;
const { COPY, TITLE } = LINE_HEIGHT;

const MODAL_WIDTH = '450px';

export const Wrapper = styled.div`
  width: ${MODAL_WIDTH};
  padding: ${S_2} ${S_4};
`;

export const Headline = styled.h1`
  ${TS_3};
  ${FW_700};
  ${TITLE};
  color: ${GREY_100};
  margin-top: 0;
`;

export const Copy = styled.p`
  ${TS_6};
  ${FW_100};
  ${COPY};
  color: ${GREY_100};
  margin: ${S_05} 0;
`;

export const SubmitButton = styled<any>(Button)`
  margin: ${S_1} 0;
`;



// WEBPACK FOOTER //
// ./src/containers/sessions/canceled-modal/styles.js